/**
 *
 * Asynchronously loads the component for Com001
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
